var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { MASK_PLACEHOLDER } from '../constants.base';
var headerNamesToMask = [
    'set-cookie',
    'cookie',
    'authorization',
    'proxyAuthorization',
];
export var maskHeaders = function (headers, customHeaderNamesToMask) {
    var e_1, _a;
    if (customHeaderNamesToMask === void 0) { customHeaderNamesToMask = []; }
    var _headers = Object.fromEntries(Object.entries(headers).map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        return [key.toLowerCase(), value];
    }));
    var _headerNamesToMask = __spreadArray(__spreadArray([], __read(headerNamesToMask), false), __read(customHeaderNamesToMask), false);
    try {
        for (var _headerNamesToMask_1 = __values(_headerNamesToMask), _headerNamesToMask_1_1 = _headerNamesToMask_1.next(); !_headerNamesToMask_1_1.done; _headerNamesToMask_1_1 = _headerNamesToMask_1.next()) {
            var headerNameToMask = _headerNamesToMask_1_1.value;
            if (headerNameToMask.toLowerCase() in _headers) {
                _headers[headerNameToMask] = MASK_PLACEHOLDER;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_headerNamesToMask_1_1 && !_headerNamesToMask_1_1.done && (_a = _headerNamesToMask_1.return)) _a.call(_headerNamesToMask_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return _headers;
};
//# sourceMappingURL=mask-headers.js.map